module.exports = __webpack_public_path__ + "static/media/moons_advanced-1800.baa66a08.jpg";